export * from './folha-de-pagamento/detail/folhaDePagamentoDetail.component';
export * from './folha-de-pagamento/edit/folhaDePagamentoEdit.component';
export * from './folha-de-pagamento/list/folhaDePagamentoList.component';
export * from './folha-de-pagamento/create/folhaDePagamentoCreate.component';
export * from  './folha-de-pagamento/tab/tab.component';
export * from './rh.component';
export * from './rh.service';
export * from './afastamento/list/afastamentoList.component';
export * from './ferias/list/feriasList.component';
export * from './cargo-e-salario/list/cargoESalarioList.component';